import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormsModule } from "@angular/forms";
import { IonicModule, LoadingController, ModalController, NavController, NavParams } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormGeradorPage } from "../../form-gerador/form-gerador.page";
import { UserProvider } from "src/app/services/user/user";
import { CommonModule } from "@angular/common";

declare var instituicaoConstants: { INSTITUICAO: any };

@Component({
  selector: "app-cadastro-busca-controle",
  templateUrl: "./cadastro-busca-controle.page.html",
  styleUrls: ["./cadastro-busca-controle.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule],
})
export class CadastroBuscaControlePage implements OnInit {
  filtro: any = { q: "" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  instituicoes: any = [];
  facebook: any = {};
  informativo: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public userProvider: UserProvider,
    private loadingController: LoadingController,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.facebook = this.navParams.get("facebook");
    this.informativo = this.navParams.get("informativoLocalizarUnidade");
    this.userProvider.getIgrejasFilhas(instituicaoConstants.INSTITUICAO, this.filtro.q).subscribe((data) => {
      this.instituicoes = data.instituicoes;
    });
  }

  ngOnInit() {}

  public async selecionar(instituicao: { id: null }) {
    this.userProvider.idInstituicao = instituicao.id;
    var cadastro: any = {};
    cadastro.form = "APP_CAD_INICIO";
    cadastro.idPessoaTipo = 5;
    cadastro.titulo = this.translate.instant("Novo Cadastro");
    cadastro.idInstituicao = instituicao.id;
    cadastro.facebook = this.facebook;
    const modalCadastro = await this.modalCtrl.create({ component: FormGeradorPage, componentProps: cadastro });
    modalCadastro.present();

    const datas = await modalCadastro.onDidDismiss();
    if (datas.data) {
      // Implementar validação de localização
      this.modalCtrl.dismiss(datas.data);
    }
  }

  onCancel() {
    this.loadInstituicaoes();
  }

  onInput() {
    this.loadInstituicaoes();
  }

  loadInstituicaoes() {
    this.userProvider.getIgrejasFilhas(instituicaoConstants.INSTITUICAO, this.filtro.q).subscribe((data) => {
      this.instituicoes = data.instituicoes;
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
